import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PeptideCalculator from "@/components/PeptideCalculator";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PeptideCalculator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
